<div class="wrapper" *ngIf="messages">
  <ng-container *ngFor="let message of messages">
    <div @myInsertRemoveTrigger class="messages">
      <div
        [ngClass]="{
          message: true,
          'message-success': message.type === 'success',
          'message-danger': message.type === 'error'
        }"
      >
        {{ message.text }}
      </div>
    </div>
  </ng-container>
</div>
